import { useState, useEffect } from "react";
import { Country, State, City } from "country-state-city";
import "./style.scss";
import { Select } from "antd";

function LocationSelector({ formData, setFormData }) {
  const [country] = useState(Country.getAllCountries());
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);

  const [filteredCountry, setFilteredCountry] = useState(
    Country.getAllCountries()
  );
  const [filteredState, setFilteredState] = useState([]);
  const [filteredCity, setFilteredCity] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const { Option } = Select;
  useEffect(() => {
    if (formData?.country) {
      const initialCountry = country.find((c) => c.name === formData.country);
      setSelectedCountry(initialCountry);

      if (initialCountry) {
        const states = State.getStatesOfCountry(initialCountry.isoCode);
        setState(states);
        setFilteredState(states);

        const initialState = states.find(
          (s) => s.name === formData.stateOrProvince
        );
        setSelectedState(initialState);

        if (initialState) {
          const cities = City.getCitiesOfState(
            initialCountry.isoCode,
            initialState.isoCode
          );
          setCity(cities);
          setFilteredCity(cities);

          const initialCity = cities.find((c) => c.name === formData.city);
          setSelectedCity(initialCity?.name || formData.city);
        }
      }
    }
  }, [formData, country]);

  useEffect(() => {
    if (selectedCountry) {
      const states = State.getStatesOfCountry(selectedCountry.isoCode);
      setState(states);
      setFilteredState(states);

      if (selectedState) {
        const cities = City.getCitiesOfState(
          selectedCountry.isoCode,
          selectedState.isoCode
        );
        setCity(cities);
        setFilteredCity(cities);
      }
    } else {
      setState([]);
      setCity([]);
    }
  }, [selectedCountry, selectedState]);

  useEffect(() => {
    handleLocationChange();
  }, [selectedCountry, selectedCity, selectedState]);

  const handleLocationChange = () => {
    setFormData((prevData) => ({
      ...prevData,
      country: selectedCountry?.name,
      stateOrProvince: selectedState?.name,
      city: selectedCity,
    }));
  };

  const handleCountryChange = (country) => {
    setSelectedCountry(country);
    setSelectedState(null);
    setCity([]);
    setFilteredCity([]);
  };

  const handleStateChange = (state) => {
    setSelectedState(state);
    const cities = City.getCitiesOfState(
      selectedCountry.isoCode,
      state.isoCode
    );
    setCity(cities);
    setFilteredCity(cities);
  };

  const handleCityChange = (city) => {
    setSelectedCity(city);
  };
  const onCountrySearch = (value) => {
    setFilteredCountry(
      country.filter((c) => c.name.toLowerCase().includes(value.toLowerCase()))
    );
  };

  const onStateSearch = (value) => {
    setFilteredState(
      state.filter((s) => s.name.toLowerCase().includes(value.toLowerCase()))
    );
  };

  const onCitySearch = (value) => {
    setFilteredCity(
      city.filter((c) => c.name.toLowerCase().includes(value.toLowerCase()))
    );
  };

  return (
    <div className="location_container">
      <div className="row">
        <div className="col">
          <Select
            showSearch
            filterOption={false}
            value={selectedCountry?.isoCode}
            onChange={(value) =>
              handleCountryChange(country.find((c) => c.isoCode === value))
            }
            className="form-select"
            placeholder="Select Country"
            onSearch={onCountrySearch}
          >
            {filteredCountry.map((country) => (
              <Option key={country.isoCode} value={country.isoCode}>
                {country.name}
              </Option>
            ))}
          </Select>
        </div>
        <div className="col">
          <Select
            showSearch
            filterOption={false}
            disabled={!selectedCountry}
            value={selectedState?.isoCode}
            onChange={(value) =>
              handleStateChange(state.find((s) => s.isoCode === value))
            }
            className="form-select"
            placeholder="Select State"
            onSearch={onStateSearch}
          >
            {filteredState.map((state) => (
              <Option key={state.isoCode} value={state.isoCode}>
                {state.name}
              </Option>
            ))}
          </Select>
        </div>
        <div className="col">
          <Select
            showSearch
            filterOption={false}
            disabled={!selectedState || !selectedCountry}
            value={selectedCity}
            onChange={(value) => handleCityChange(value)}
            className="form-select"
            placeholder="Select City"
            onSearch={onCitySearch}
          >
            {filteredCity.map((city) => (
              <Option key={city.name} value={city.name}>
                {city.name}
              </Option>
            ))}
          </Select>
        </div>
      </div>
    </div>
  );
}

export default LocationSelector;
